export default {
  ar: {
    title: 'رياكت پرو سايد بار',
    sidebarTitle: 'پرو سايد بار',
    description: 'شريط جانبي مع قوائم منسدلة وعدد غير محدود من القوائم الفرعية المتداخلة',
    dashboard: 'لوحة القيادة',
    components: 'مكونات',
    dropdown: 'اسقاط',
    submenu: 'قائمة فرعية',
    multiLevel: 'متعدد المستويات',
    collapsed: 'انطوى',
    rtl: 'ر ت ل',
    image: 'صورة الخلفية',
    new: 'جديد',
    withPrefix: 'مع البادئة',
    withSuffix: 'مع اللاحقة',
    viewSource: 'عرض الكود',
  },
  en: {
    title: 'React Pro Sidebar',
    sidebarTitle: 'Pro Sidebar',
    description:
      'React sidebar library with dropdown menus and unlimited number of nested submenus',
    dashboard: 'Dashboard',
    components: 'Components',
    dropdown: 'Dropdown',
    submenu: 'Submenu',
    multiLevel: 'Multi Level',
    collapsed: 'Collapsed',
    rtl: 'RTL',
    image: 'Background image',
    new: 'NEW',
    withPrefix: 'With Prefix',
    withSuffix: 'With Suffix',
    viewSource: 'View Source',
  },
};